(function () {
  var LIMIT = 50;
  var mq = window.matchMedia('(max-width: 767px)');

  function wordCount(text) {
    return text.trim().split(/\s+/).filter(Boolean).length;
  }

  function lastTextBlock(el) {
    var blocks = el.querySelectorAll('p, h1, h2, h3, h4, h5, h6');
    return blocks.length ? blocks[blocks.length - 1] : el;
  }

  function firstMore(el) {
    return el.querySelector('.pys-desc-more');
  }

  function placeBtn(el, btn, expanded) {
    if (expanded) {
      lastTextBlock(el).appendChild(btn);
      return;
    }
    var more = firstMore(el);
    if (more && more.parentNode) more.parentNode.insertBefore(btn, more);
    else el.appendChild(btn);
  }

  function findWordNode(el, limit) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var count = 0;
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      var parts = value.split(/(\s+)/);
      var offset = 0;
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (part && !/^\s+$/.test(part)) {
          count += 1;
          if (count === limit) {
            return { node: node, end: offset + part.length };
          }
        }
        offset += part.length;
      }
    }
    return null;
  }

  // Split at the 50th word, then wrap ONLY following siblings at each
  // ancestor so the original <p> stays intact. Never use extractContents:
  // it clones ancestor blocks and turns a mid-sentence cut into a new <p>.
  function wrapAfterWord(el, limit) {
    var hit = findWordNode(el, limit);
    if (!hit) return false;
    var node = hit.node;
    if (hit.end < node.nodeValue.length) {
      node.splitText(hit.end);
    }
    var current = node;
    while (current && current !== el) {
      var parent = current.parentNode;
      if (!parent) break;
      if (current.nextSibling) {
        var wrap = document.createElement('span');
        wrap.className = 'pys-desc-more';
        while (current.nextSibling) {
          wrap.appendChild(current.nextSibling);
        }
        parent.appendChild(wrap);
      }
      current = parent;
    }
    return !!el.querySelector('.pys-desc-more');
  }

  function setup(el) {
    if (el.dataset.pysExpandReady) return;
    if (wordCount(el.innerText) <= LIMIT) return;
    if (!wrapAfterWord(el, LIMIT)) return;
    el.dataset.pysExpandReady = 'true';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pys-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Show more';
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Show more';
      placeBtn(el, btn, open);
    });
    placeBtn(el, btn, false);
    apply(el, btn);
  }

  function apply(el, btn) {
    var shouldCollapse = mq.matches;
    el.classList.toggle('pys-desc-collapsible', shouldCollapse);
    if (btn) btn.hidden = !shouldCollapse;
    if (!shouldCollapse) {
      el.classList.add('is-expanded');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = 'Show less';
      }
    } else if (!el.classList.contains('is-expanded')) {
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Show more';
      }
    }
  }

  function init() {
    document.querySelectorAll('.pys-expand-desc .rich-text__text').forEach(function (el) {
      setup(el);
      apply(el, el.querySelector('.pys-desc-toggle'));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  mq.addEventListener('change', init);
})();
